import React from 'react';
import { getPhoneDisplayLines } from '../utils/phoneCanonical';

function PhoneNumberDisplay({ phone, className = '', headingClass = 'text-xl font-bold' }) {
  const { international, local } = getPhoneDisplayLines(phone);

  return (
    <div className={className}>
      <p className={headingClass}>{international}</p>
      {local && (
        <p className="text-sm text-gray-600 mt-0.5">
          <span className="text-gray-500">Local: </span>
          {local}
        </p>
      )}
    </div>
  );
}

export default PhoneNumberDisplay;
